import { createContext } from "react";

export const RentContext = createContext(null);
